// @ts-ignore
export const all = (state) => state.all.map((press: any) => ({
  ...press,
  pressDateParsed: press.pressDate ? convertDate(press.pressDate) : '',
}));

/**
 * Converts a dd.mm.YYYY date to a time value
 * @param date
 */
function convertDate(date: string) {
  const dateParts = date.split('.');
  return new Date(parseInt(dateParts[2], 10), parseInt(dateParts[1], 10) - 1, parseInt(dateParts[0], 10)).getTime();
}

// @ts-ignore
export const one = (state) => state.one;
